module.exports = __webpack_public_path__ + "static/media/Logoj.d49ce715.png";